
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 4a3 3 0 00-3 3v2c0 .552.475.98.959 1.245a2 2 0 010 3.51C2.475 14.021 2 14.448 2 15v2a3 3 0 003 3h14a3 3 0 003-3v-2c0-.552-.474-.98-.959-1.245a2 2 0 010-3.51C21.526 9.979 22 9.552 22 9V7a3 3 0 00-3-3H5zm7.944 4.717c-.31-.895-1.577-.895-1.889 0l-.237.684a1 1 0 01-.924.671l-.724.015c-.948.02-1.34 1.224-.584 1.797l.577.437a1 1 0 01.353 1.087l-.21.693c-.274.907.75 1.651 1.529 1.11l.594-.414a1 1 0 011.142 0l.594.414c.779.541 1.803-.203 1.529-1.11l-.21-.693a1 1 0 01.353-1.087l.577-.437c.755-.573.364-1.777-.584-1.797l-.724-.014a1 1 0 01-.924-.672l-.238-.684z"}})])
          )
        }
      }
    